"use client"

import { getDefaultVariationSku } from "src/components/product-details/createResolvedProductData"
import { DetailProductData } from "src/data/product-details/types"
import { useSelectedSkuBySlug } from "./state"

export function useSelectedVariationByProduct(product: DetailProductData) {
  const defaultVariationSku = getDefaultVariationSku(product)

  const selectedSku = useSelectedSkuBySlug(product.slug, defaultVariationSku)

  return product.variations?.find((variation) => variation.sku === selectedSku)
}
